import React from 'react';
import { useTranslations } from '../../../locales/useTranslations';
import { BiEnvelope, BiCalendar, BiShield, BiServer } from 'react-icons/bi';

const MailServerBenefits = () => {
  const { t } = useTranslations();
  const items = [
    { icon: BiEnvelope, text: t('managedServices_mailServer_benefit1') },
    { icon: BiCalendar, text: t('managedServices_mailServer_benefit2') },
    { icon: BiShield, text: t('managedServices_mailServer_benefit3') },
    { icon: BiServer, text: t('managedServices_mailServer_benefit4') },
  ];

  return (
    <section className="ms-section ms-section--benefits">
      <div className="container">
        <div className="ms-section-header ms-section-header--center">
          <span className="ms-section__badge">{t('managedServices_mailServer_benefits_badge')}</span>
          <h2 className="ms-section__title">{t('managedServices_mailServer_benefits_title')}</h2>
          <p className="ms-section__lead ms-section__lead--center">
            {t('managedServices_mailServer_benefits_intro')}
          </p>
        </div>
        <div className="row">
          {items.map((item, index) => {
            const Icon = item.icon;
            return (
              <div key={index} className="col-lg-6 col-md-6 mb-4">
                <div className="ms-benefit-card">
                  <div className="ms-benefit-card__icon">
                    <Icon />
                  </div>
                  <p>{item.text}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default MailServerBenefits;
